import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


@Injectable({
  providedIn: 'root'
})

export class LoadingService {

  public show$ = new BehaviorSubject(false);
  public texto$ = new BehaviorSubject('');

  open(title? : string) {
    queueMicrotask(() => {
      this.texto$.next(title ?? '');
      this.show$.next(true);
    });
  }

  close(){
    queueMicrotask(() => {
      this.show$.next(false);
      this.texto$.next('');
    });
  }


}
